// extracted by mini-css-extract-plugin
export var cardLayout = "_6z-1";
export var paginationContainer = "_6z-0";